import { api } from 'app/config/apiConfig';
import { RentOptionDocument } from '../model/types';

export const deleteRentOptionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    deleteRentOption: builder.mutation<RentOptionDocument, string>({
      query: (rentOptionId: string) => ({
        url: `/contracts/rent/rent-options/${rentOptionId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Rent options'],
    }),
  }),
});

export const { useDeleteRentOptionMutation } = deleteRentOptionApi;
